var React = require('react');

function DigitalOceanMark (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"DigitalOcean home"),React.createElement("g",{"fill":"#0080FF","fillRule":"evenodd","key":1},[React.createElement("path",{"d":"M24.9153 50v-9.661c10.226 0 18.1638-10.1413 14.2372-20.904-1.4406-3.983-4.6327-7.1751-8.6158-8.6158C19.774 6.921 9.6327 14.8305 9.6327 25.0565H0C0 8.7571 15.7627-3.9548 32.8531 1.3842c7.4576 2.3446 13.418 8.2768 15.7345 15.7344C53.9266 34.2373 41.2429 50 24.9153 50","key":0}),React.createElement("path",{"d":"M15.339 40.3672h9.6045v-9.6045H15.339zM7.9379 47.7684h7.401v-7.4012H7.938zM1.7514 40.3672H7.938v-6.1864H1.7514z","key":1})])]);
}

DigitalOceanMark.defaultProps = {"viewBox":"0 0 50 50"};

module.exports = DigitalOceanMark;

DigitalOceanMark.default = DigitalOceanMark;
